'use client';

import clsx from 'clsx';
import { FC, InputHTMLAttributes } from 'react';

export type InputProps = InputHTMLAttributes<HTMLInputElement> & {
    uiSize?: 'default' | 'compact';
};

const Input: FC<InputProps> = ({ className, uiSize = 'default', ...props }) => {
    return (
        <input
            className={clsx(
                `focus:ring-blue-500 focus:outline-none appearance-none w-full
                text-slate-900 placeholder-slate-400 rounded-md ring-1
                ring-slate-200 shadow-sm`,
                uiSize === 'default' && 'text-sm leading-5 py-1.5 pl-4 min-h-[40px]',
                uiSize === 'compact' && 'text-xs leading-4 py-1 pl-3 min-h-[32px]',
                className,
            )}
            {...props}
        />
    );
};

export default Input;
